export default __webpack_public_path__ + "static/media/ops_module.201920cd.svg";